import { render, staticRenderFns } from "./MainInfoSection.vue?vue&type=template&id=e75b75f8&"
import script from "./MainInfoSection.vue?vue&type=script&lang=js&"
export * from "./MainInfoSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports